/**@jsx jsx */
import { Container, jsx, Flex } from "theme-ui";
import MasterDisclaimer from "./MasterDisclaimer";
import olaLogo from "../images/ola.svg";

const footerLinks = [
  {
    label: "Privacy Policy",
    href: "https://www.ccfi.com/privacy/",
    newWindow: "true",
  },
  {
    label: "Locations",
    href: "https://www.google.com/maps/search/?api=1&query=36.85667059967011%2C-76.20202207151335&query_place_id=ChIJC6NlHUKWuokRe2iY874ih8A",
    newWindow: "false",
  },
  {
    label: "Rates & Terms",
    href: "https://www.ccfi.com/terms/",
    newWindow: "true",
  },
];

const DefaultFooter = () => {
  return (
    <footer
      sx={{
        background: "#f1f1f1",
        pt: "32px",
        pb: "20px",
        borderTopColor: "moneyGreen",
        borderTopStyle: "solid",
        borderTopWidth: ["4px", null, null, "5px", "6px"],
      }}
    >
      <Container>
        <div
          sx={{
            display: "flex",
            flexDirection: ["column", null, null, "row"],
            gap: ["24px", null, null, "60px"],
            pb: "24px",
          }}
        >
          <ul
            sx={{
              textAlign: ["center", null, null, "start", "start"],
              display: "flex",
              flexDirection: ["column", null, null, "row"],
              alignItems: [null, null, null, "center"],
              gap: ["10px", null, null, "10px"],
              listStyle: "none",
              "& li:last-of-type span": {
                display: "none",
              },
            }}
          >
            {footerLinks.map(({ label, href, newWindow }) => (
              <li key={href}>
                <a
                  href={href}
                  target={newWindow ? "_blank" : "_self"}
                  sx={{ variant: "text.footerLink" }}
                >
                  {label}
                </a>
                <span
                  sx={{
                    display: ["none", null, null, "inline"],
                    variant: "text.footerLink",
                  }}
                >
                  {" "}
                  |{" "}
                </span>
              </li>
            ))}
          </ul>{" "}
          <Flex
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "30px",
            }}
          >
            <div>
              <a
                href="https://onlinelendersalliance.org/consumer-resources/look-for-the-ola-seal/"
                target="_blank"
              >
                <img src={olaLogo} loading="lazy" alt="Ola Logo" />
              </a>
            </div>
          </Flex>
        </div>
        <MasterDisclaimer />
      </Container>
    </footer>
  );
};

export default DefaultFooter;
